import eventBus from "@monorepo/utils/src/eventBus";
import { MONITORING_EVENT_BUS_EVENTS } from "@monorepo/utils/src/eventBus/events/monitoringEvents";
import { formLoadingPayload } from "@monorepo/utils/src/eventBus/utils/formLoadingPayload";
import { LOADING_STATUS } from "@monorepo/utils/src/eventBus/types/loadingTypes";

export const getQuery = (): void => {
  eventBus.$emit(MONITORING_EVENT_BUS_EVENTS.REFRESH_EVENTS, formLoadingPayload(MONITORING_EVENT_BUS_EVENTS.REFRESH_EVENTS, LOADING_STATUS.START));
};
